export default __webpack_public_path__ + "static/media/480_business01-jp-mobile.608636c8.png";